export default __webpack_public_path__ + "static/media/architecture-2.e9c8caff.webp";